var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_vm._m(0),_c('div',{staticStyle:{"margin":"64px 0","font-size":"32px","font-weight":"600"}},[_vm._v(" 欢迎使用"+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"64px 0"}},[_c('img',{staticStyle:{"width":"100%","max-width":"640px"},attrs:{"src":require("@/assets/images/logo.png"),"alt":"Logo"}})])
}]

export { render, staticRenderFns }